import React, { useState, useEffect } from "react";

const ProcessingWithDots = () => {
	const [dots, setDots] = useState("");

	useEffect(() => {
		const interval = setInterval(() => {
			setDots((prevDots) => (prevDots.length < 3 ? prevDots + "." : ""));
		}, 200); // Change dots every 500ms

		return () => clearInterval(interval); // Cleanup interval on component unmount
	}, []);

	return (
		<span className="processing-with-dots" style={{ display: "inline-block", width: "8.7ch", marginLeft:"-4px" }}>
			Processing{dots}
		</span>
	);
};

export default ProcessingWithDots;